import { Observable } from "rxjs";
import { ICommand } from "../../modules/records/commands/i-command";
import { IApiService } from "../../modules/records/models/api/i-api-service";
import { RecordsManager } from "../../modules/records/records-manager";

export class CreateTagOnlineRepCommand<
  T extends object & { disabled: boolean },
  S extends IApiService<T> & {
    showDialogTagOnlineRep: (el: T) => Observable<any>;
  }
> implements ICommand<T, S>
{
  private receiver!: RecordsManager<T>;
  type: "primary" | "warn" | "accent" = "accent";
  layout: "flat" | "raised" | "normal" | undefined = "raised";
  label = "TAG";
  constructor(public service: S) {}
  execute(el: T) {
    this.service.showDialogTagOnlineRep(el).subscribe((res) => {
      if (res) {
        this.receiver.onSuccess();
      }
    });
  }

  setReceiver(receiver: RecordsManager<T>) {
    this.receiver = receiver;
  }

  isDisabled(el: T) {
    return false;
  }

  isHidden(el: T) {
    return false;
  }

}